/**
 * Sanitizes a numeric input string by removing all non-digit characters
 * and trimming the result to a specified maximum length.
 *
 * @param {string} value - The input string to sanitize.
 * @param {number} maxLength - The maximum allowed length of the sanitized number.
 * @returns {string} The sanitized numeric string with only digits, limited to the specified length.
 *
 * @example
 * // Removes non-digits and limits to 5 characters
 * sanitizeNumberInput("12a3-45b6", 5);
 * // Returns: "12345"
 *
 * @example
 * // Handles empty or undefined input
 * sanitizeNumberInput("", 10);
 * // Returns: ""
 */
export function sanitizeNumberInput(value: string, maxLength: number) {
    if (!value) return '';
    return value.replace(/\D/g, '').slice(0, maxLength);
}
